export const siteInfo = {
  name: "久久视频",
  tagline: "免费高清影视聚合平台",
  description: "久久视频聚合西瓜视频、樱花视频、糖豆视频等主流平台的高清片源，提供最新上映院线电影蓝光画质超清播放，免费不收费在线看。",
  keywords: ["久久视频", "西瓜视频免费", "高清片源", "最新上映", "院线电影", "蓝光画质", "超清播放", "免费在线观看"],
  url: "https://www.jiujiuvideo.com",
  foundingYear: 2019,
  email: "contact@jiujiuvideo.com",
  phone: "400-888-9999",
  address: "北京市朝阳区望京街道10号院久久视频大厦",
};

export const categories = [
  { slug: "movie", name: "电影", icon: "ri-movie-2-line", description: "最新院线大片、经典电影、动作片、喜剧片等海量电影资源" },
  { slug: "tv", name: "电视剧", icon: "ri-tv-2-line", description: "热播国产剧、韩剧、美剧、日剧，追剧不等待" },
  { slug: "variety", name: "综艺", icon: "ri-live-line", description: "热门综艺节目、真人秀、脱口秀，欢乐不断" },
  { slug: "anime", name: "动漫", icon: "ri-rocket-2-line", description: "日本动漫、国产动漫、剧场版动画，二次元世界" },
  { slug: "documentary", name: "纪录片", icon: "ri-film-line", description: "自然、人文、历史、科技纪录片，开拓视野" },
];

export const featuredVideos = [
  {
    id: 1,
    title: "流浪地球3",
    category: "movie",
    year: 2026,
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20space%20station%20in%20deep%20space%2C%20dramatic%20cinematic%20lighting%2C%20orange%20and%20teal%20color%20grading%2C%20movie%20poster%20style%2C%20clean%20composition%20on%20dark%20background&width=800&height=600&seq=video-featured-01&orientation=landscape",
    description: "人类文明的命运再次悬于一线，流浪地球计划进入全新阶段...",
    tags: ["科幻", "冒险", "国产"],
    isNew: true,
    quality: "蓝光4K",
    source: "西瓜视频",
  },
  {
    id: 2,
    title: "封神第二部",
    category: "movie",
    year: 2026,
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythology%20fantasy%20film%20poster%20with%20warriors%20in%20traditional%20armor%20and%20mythical%20creatures%2C%20dramatic%20epic%20battle%20scene%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%20on%20dark%20background&width=800&height=600&seq=video-featured-02&orientation=landscape",
    description: "朝歌风云再起，姜子牙率领众神迎战纣王的终极对决...",
    tags: ["奇幻", "史诗", "国产"],
    isNew: true,
    quality: "蓝光4K",
    source: "樱花视频",
  },
  {
    id: 3,
    title: "速度与激情11",
    category: "movie",
    year: 2026,
    rating: 8.7,
    image: "https://readdy.ai/api/search-image?query=High%20octane%20action%20car%20chase%20movie%20poster%20with%20sports%20cars%20racing%20through%20city%20streets%2C%20explosive%20action%2C%20warm%20orange%20sunset%20lighting%2C%20cinematic%20movie%20poster%20composition&width=800&height=600&seq=video-featured-03&orientation=landscape",
    description: "唐老大带领家族迎来前所未有的终极挑战，速度与激情再升级...",
    tags: ["动作", "赛车", "好莱坞"],
    isNew: false,
    quality: "蓝光1080P",
    source: "糖豆视频",
  },
  {
    id: 4,
    title: "哪吒之魔童闹海",
    category: "anime",
    year: 2025,
    rating: 9.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20featuring%20mythological%20boy%20character%20with%20magical%20powers%2C%20vibrant%20warm%20colors%2C%20dramatic%20cinematic%20composition%2C%20traditional%20Chinese%20art%20style%20blended%20with%203D%20animation&width=800&height=600&seq=video-featured-04&orientation=landscape",
    description: "哪吒与敖丙携手对抗天命，东方神话的又一次华丽绽放...",
    tags: ["动画", "神话", "国产"],
    isNew: false,
    quality: "蓝光4K",
    source: "西瓜视频",
  },
  {
    id: 5,
    title: "星际穿越2：新边疆",
    category: "movie",
    year: 2026,
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Cosmic%20sci-fi%20film%20poster%20with%20wormhole%20and%20distant%20galaxies%2C%20astronaut%20floating%20near%20event%20horizon%2C%20deep%20space%20colors%2C%20cinematic%20movie%20poster%20style%20with%20dramatic%20lighting&width=800&height=600&seq=video-featured-05&orientation=landscape",
    description: "人类踏上探索新星系的旅程，穿越未知的宇宙边疆...",
    tags: ["科幻", "冒险", "好莱坞"],
    isNew: true,
    quality: "蓝光4K",
    source: "樱花视频",
  },
  {
    id: 6,
    title: "长安十二时辰",
    category: "tv",
    year: 2025,
    rating: 9.1,
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20set%20in%20ancient%20Tang%20Dynasty%20city%2C%20elaborate%20traditional%20costumes%2C%20lantern-lit%20night%20scene%2C%20warm%20golden%20tones%2C%20cinematic%20composition&width=800&height=600&seq=video-featured-06&orientation=landscape",
    description: "唐朝天宝年间，长安城内一场惊天阴谋正在酝酿...",
    tags: ["古装", "悬疑", "国产剧"],
    isNew: false,
    quality: "蓝光1080P",
    source: "糖豆视频",
  },
];

export const hotVideos = [
  {
    id: 7,
    title: "王牌对王牌第九季",
    category: "variety",
    year: 2026,
    rating: 8.3,
    image: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20with%20colorful%20lighting%20and%20celebrities%20playing%20games%2C%20bright%20energetic%20atmosphere%2C%20entertainment%20show%20poster%20style%2C%20warm%20vibrant%20colors&width=800&height=600&seq=video-hot-01&orientation=landscape",
    tags: ["综艺", "搞笑", "明星"],
    quality: "超清",
  },
  {
    id: 8,
    title: "间谍过家家第三季",
    category: "anime",
    year: 2026,
    rating: 9.3,
    image: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20family%20comedy%20poster%20with%20spy%20family%20theme%2C%20warm%20pastel%20colors%2C%20playful%20atmosphere%2C%20clean%20animation%20art%20style%20on%20light%20background&width=800&height=600&seq=video-hot-02&orientation=landscape",
    tags: ["动漫", "喜剧", "日本"],
    quality: "超清",
  },
  {
    id: 9,
    title: "地球脉动第四季",
    category: "documentary",
    year: 2025,
    rating: 9.8,
    image: "https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%20with%20stunning%20wildlife%20and%20landscapes%2C%20majestic%20mountains%20and%20oceans%2C%20rich%20natural%20colors%2C%20cinematic%20BBC%20style%20nature%20photography&width=800&height=600&seq=video-hot-03&orientation=landscape",
    tags: ["纪录片", "自然", "BBC"],
    quality: "蓝光4K",
  },
  {
    id: 10,
    title: "狂飙2：暗流涌动",
    category: "tv",
    year: 2026,
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20noir%20aesthetic%2C%20mysterious%20urban%20night%20scene%2C%20suspenseful%20atmosphere%2C%20dark%20warm%20tones%2C%20cinematic%20composition&width=800&height=600&seq=video-hot-04&orientation=landscape",
    tags: ["刑侦", "悬疑", "国产剧"],
    quality: "蓝光1080P",
  },
  {
    id: 11,
    title: "奔跑吧兄弟第十二季",
    category: "variety",
    year: 2026,
    rating: 7.9,
    image: "https://readdy.ai/api/search-image?query=Outdoor%20Chinese%20variety%20show%20with%20celebrities%20running%20and%20competing%2C%20sunny%20day%20at%20scenic%20location%2C%20energetic%20vibrant%20atmosphere%2C%20entertainment%20show%20poster%20style&width=800&height=600&seq=video-hot-05&orientation=landscape",
    tags: ["综艺", "户外", "竞技"],
    quality: "超清",
  },
  {
    id: 12,
    title: "进击的巨人最终季完结篇",
    category: "anime",
    year: 2025,
    rating: 9.6,
    image: "https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20anime%20poster%20with%20giant%20titans%20and%20soldiers%2C%20dramatic%20action%20scene%2C%20cinematic%20lighting%2C%20intense%20atmosphere%2C%20Japanese%20animation%20art%20style&width=800&height=600&seq=video-hot-06&orientation=landscape",
    tags: ["动漫", "动作", "奇幻"],
    quality: "蓝光1080P",
  },
];

export const categoryVideos: Record<string, typeof featuredVideos> = {
  movie: [
    ...featuredVideos.filter((v) => v.category === "movie"),
    {
      id: 13,
      title: "唐人街探案5",
      category: "movie",
      year: 2026,
      rating: 8.4,
      image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20detective%20film%20poster%20with%20detectives%20in%20colorful%20international%20city%20setting%2C%20playful%20mystery%20theme%2C%20warm%20vibrant%20colors%2C%20cinematic%20poster%20composition&width=800&height=600&seq=video-cat-movie-01&orientation=landscape",
      tags: ["喜剧", "悬疑", "国产"],
      quality: "蓝光4K",
      source: "西瓜视频",
    },
    {
      id: 14,
      title: "阿凡达4：水之启示",
      category: "movie",
      year: 2026,
      rating: 8.8,
      image: "https://readdy.ai/api/search-image?query=Sci-fi%20fantasy%20film%20poster%20with%20blue%20alien%20characters%20in%20lush%20alien%20ocean%20world%2C%20bioluminescent%20environment%2C%20cinematic%20epic%20scale%2C%20warm%20underwater%20lighting&width=800&height=600&seq=video-cat-movie-02&orientation=landscape",
      tags: ["科幻", "冒险", "好莱坞"],
      quality: "蓝光4K",
      source: "樱花视频",
    },
  ],
  tv: [
    ...featuredVideos.filter((v) => v.category === "tv"),
    {
      id: 15,
      title: "庆余年第三季",
      category: "tv",
      year: 2026,
      rating: 9.0,
      image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%20with%20scholarly%20hero%20in%20ancient%20palace%20setting%2C%20elaborate%20costumes%2C%20warm%20golden%20lighting%2C%20cinematic%20composition&width=800&height=600&seq=video-cat-tv-01&orientation=landscape",
      tags: ["古装", "权谋", "国产剧"],
      quality: "蓝光1080P",
      source: "糖豆视频",
    },
    {
      id: 16,
      title: "鱿鱼游戏第三季",
      category: "tv",
      year: 2026,
      rating: 8.5,
      image: "https://readdy.ai/api/search-image?query=Korean%20thriller%20drama%20poster%20with%20colorful%20playground%20aesthetic%20and%20sinister%20undertone%2C%20dramatic%20contrast%20lighting%2C%20suspenseful%20atmosphere%2C%20cinematic%20poster%20style&width=800&height=600&seq=video-cat-tv-02&orientation=landscape",
      tags: ["韩剧", "悬疑", "惊悚"],
      quality: "超清",
      source: "西瓜视频",
    },
  ],
  variety: [
    ...featuredVideos.filter((v) => v.category === "variety"),
    {
      id: 17,
      title: "向往的生活第九季",
      category: "variety",
      year: 2026,
      rating: 8.2,
      image: "https://readdy.ai/api/search-image?query=Chinese%20rural%20lifestyle%20variety%20show%20poster%20with%20celebrities%20enjoying%20countryside%20life%2C%20warm%20sunset%20lighting%2C%20peaceful%20pastoral%20scene%2C%20relaxing%20atmosphere&width=800&height=600&seq=video-cat-var-01&orientation=landscape",
      tags: ["综艺", "生活", "慢综艺"],
      quality: "超清",
      source: "樱花视频",
    },
  ],
  anime: [
    ...featuredVideos.filter((v) => v.category === "anime"),
    {
      id: 18,
      title: "鬼灭之刃：无限城篇",
      category: "anime",
      year: 2026,
      rating: 9.4,
      image: "https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20film%20poster%20with%20samurai%20characters%20in%20dynamic%20action%20pose%2C%20vibrant%20flame%20and%20water%20effects%2C%20cinematic%20anime%20art%20style%2C%20dramatic%20lighting&width=800&height=600&seq=video-cat-anime-01&orientation=landscape",
      tags: ["动漫", "动作", "日本"],
      quality: "蓝光1080P",
      source: "糖豆视频",
    },
  ],
  documentary: [
    ...featuredVideos.filter((v) => v.category === "documentary"),
    {
      id: 19,
      title: "舌尖上的中国第五季",
      category: "documentary",
      year: 2025,
      rating: 9.3,
      image: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20traditional%20cuisine%20close-up%2C%20steaming%20hot%20dishes%2C%20warm%20rich%20colors%2C%20appetizing%20food%20photography%20style%2C%20cultural%20cooking%20scene&width=800&height=600&seq=video-cat-doc-01&orientation=landscape",
      tags: ["纪录片", "美食", "文化"],
      quality: "蓝光4K",
      source: "西瓜视频",
    },
  ],
};

export const articles = [
  {
    id: 1,
    title: "2026年暑期档最值得期待的十部国产大片",
    category: "movie",
    date: "2026-07-28",
    author: "影视编辑小久",
    summary: "暑期档已经过半，但精彩才刚刚开始。我们为你盘点了即将上映的十部国产大片，从科幻巨制到现实题材，总有一部适合你。",
    content: `<p>每年暑期档都是国产电影的必争之地，2026年也不例外。从7月初开始，多部备受期待的国产大片陆续定档，让影迷们大饱眼福。</p>
<h3>科幻巨制引领风潮</h3>
<p>《流浪地球3》无疑是今年暑期档最受瞩目的作品。作为中国科幻电影的标杆之作，该系列第三部将故事推进到全新的宇宙尺度，视觉特效再次突破天花板。影片上映首日即打破多项票房纪录。</p>
<p>另一部科幻力作《明日战记2》同样不容错过，古天乐领衔的硬核机甲战斗场面让观众热血沸腾。</p>
<h3>现实题材异军突起</h3>
<p>今年暑期档的现实题材影片质量普遍较高。《我不是药神2》延续前作的社会关怀，《人生大事2》继续讲述温暖人心的市井故事，这些影片在情感深度和社会意义上都有着出色的表现。</p>
<h3>动画电影持续发力</h3>
<p>《哪吒之魔童闹海》以惊人的票房成绩证明了中国动画电影的无限潜力，精美的画面和深刻的主题让这部作品成为暑期档的一匹黑马。</p>`,
    image: "https://readdy.ai/api/search-image?query=Cinema%20movie%20theater%20interior%20with%20red%20seats%20and%20large%20screen%20showing%20epic%20film%20scene%2C%20dramatic%20lighting%2C%20warm%20atmosphere%2C%20cinematic%20photography%20style&width=1200&height=600&seq=article-01&orientation=landscape",
    tags: ["暑期档", "国产电影", "影评"],
  },
  {
    id: 2,
    title: "蓝光画质与普通高清的区别：为什么你应该选择蓝光片源",
    category: "tech",
    date: "2026-07-25",
    author: "技术小编阿久",
    summary: "很多观众在观看影视作品时都会面临画质选择的问题。蓝光、超清、高清、标清...这些画质到底有什么区别？本文将为你详细解析。",
    content: `<p>在数字视频时代，画质是影响观影体验的核心因素之一。随着显示设备的不断升级，高画质内容的需求也在快速增长。</p>
<h3>分辨率对比</h3>
<p>蓝光画质通常指1080P（1920×1080）或4K（3840×2160）分辨率，而普通高清（720P）的分辨率仅为1280×720。这意味着蓝光画面包含的信息量是普通高清的2.25倍（1080P）到9倍（4K）。</p>
<h3>码率差异</h3>
<p>除了分辨率，码率也是决定画质的重要因素。蓝光视频的码率通常在20-40Mbps，而在线高清视频的码率往往只有5-8Mbps。更高的码率意味着更少的压缩伪影、更丰富的色彩层次和更流畅的动态画面。</p>
<h3>音频质量</h3>
<p>蓝光影碟通常包含无损音频格式如DTS-HD Master Audio或Dolby TrueHD，而在线流媒体的音频往往是压缩格式。对于拥有家庭影院系统的用户来说，这一差异尤为明显。</p>
<h3>久久视频的画质承诺</h3>
<p>久久视频聚合各大平台的高清片源，优先为用户提供蓝光画质的内容。我们相信，好的内容值得用最好的画质来呈现。</p>`,
    image: "https://readdy.ai/api/search-image?query=High%20definition%20TV%20screen%20displaying%20vibrant%20nature%20scene%20with%20incredible%20detail%2C%20modern%20living%20room%20setup%2C%20warm%20ambient%20lighting%2C%20cinematic%20quality%20comparison%20concept&width=1200&height=600&seq=article-02&orientation=landscape",
    tags: ["蓝光画质", "高清", "技术科普"],
  },
  {
    id: 3,
    title: "从《狂飙》到《漫长的季节》：国产剧的黄金时代来了",
    category: "tv",
    date: "2026-07-20",
    author: "剧评人小久",
    summary: "近年来，国产电视剧的制作水准突飞猛进。从悬疑刑侦到年代剧，从奇幻古装到现实主义，国产剧正在迎来一个前所未有的黄金时代。",
    content: `<p>如果说前几年的国产剧还在摸索中前进，那么近两年的作品已经展现出了成熟的气质。《狂飙》《漫长的季节》《三体》等现象级作品的出现，标志着国产剧集已经进入了一个全新的阶段。</p>
<h3>制作水准的全面提升</h3>
<p>从服化道到摄影灯光，从剧本打磨到后期制作，国产剧的工业化水平正在快速提高。《长安十二时辰》的美术设计、《三体》的视觉特效、《漫长的季节》的摄影风格，都达到了国际一流水准。</p>
<h3>题材的多元化探索</h3>
<p>不再局限于古装偶像和都市爱情，国产剧的题材边界正在不断拓宽。悬疑刑侦、科幻奇幻、社会现实、历史正剧...各种类型都有优秀作品涌现。</p>
<h3>演员表演的突破</h3>
<p>一批实力派演员的精彩表演为这些作品注入了灵魂。从张译在《狂飙》中的精湛演技，到范伟在《漫长的季节》中的令人动容的表演，国产剧的表演水准正在被不断拉高。</p>`,
    image: "https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20production%20set%20with%20professional%20film%20crew%20and%20actors%20in%20costume%2C%20cinematic%20lighting%20setup%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20professional%20film%20production%20photography&width=1200&height=600&seq=article-03&orientation=landscape",
    tags: ["国产剧", "剧评", "影视产业"],
  },
  {
    id: 4,
    title: "动漫推荐：2026年最值得追的十部日本新番",
    category: "anime",
    date: "2026-07-15",
    author: "动漫小编久酱",
    summary: "新一季的日本动漫新番已经陆续开播，我们精选了十部口碑和制作都在线的作品，无论你是热血少年还是文艺青年，都能找到心仪之作。",
    content: `<p>每个季度的日本新番都是动漫爱好者最期待的盛宴。2026年夏季新番已经陆续开播，让我们来看看哪些作品值得追。</p>
<h3>续作大作云集</h3>
<p>《间谍过家家》第三季、《鬼灭之刃：无限城篇》等超人气续作无疑是本季最大的看点。这些作品在前几季已经积累了庞大的粉丝基础，新一季的制作水准有增无减。</p>
<h3>原创作品惊喜不断</h3>
<p>除了续作，本季的原创动画同样令人期待。多部原创作品凭借独特的设定和精良的制作脱颖而出，展现了日本动画产业的创新活力。</p>
<h3>国产动漫也不甘示弱</h3>
<p>与此同时，国产动漫也在持续发力。《哪吒之魔童闹海》的票房奇迹之后，多部国产动画电影和番剧正在制作中，令人期待。</p>`,
    image: "https://readdy.ai/api/search-image?query=Anime%20streaming%20display%20wall%20with%20colorful%20anime%20posters%20and%20characters%2C%20modern%20entertainment%20room%20setup%2C%20vibrant%20otaku%20culture%20atmosphere%2C%20warm%20ambient%20lighting&width=1200&height=600&seq=article-04&orientation=landscape",
    tags: ["动漫", "日本新番", "推荐"],
  },
  {
    id: 5,
    title: "久久视频使用指南：如何找到你想看的影视内容",
    category: "guide",
    date: "2026-07-10",
    author: "产品小编久久",
    summary: "久久视频聚合了多个平台的海量内容，为了帮助你更高效地找到心仪的影视作品，我们整理了这份详细的使用指南。",
    content: `<p>久久视频作为一个影视聚合平台，汇聚了西瓜视频、樱花视频、糖豆视频等多个主流平台的高清内容。这里有一份使用指南，帮助你快速上手。</p>
<h3>分类浏览</h3>
<p>在首页和导航栏中，你可以按照电影、电视剧、综艺、动漫、纪录片等分类来浏览内容。每个分类下都有热门推荐和最新上架的作品。</p>
<h3>搜索功能</h3>
<p>如果你有明确的观影目标，可以直接使用搜索功能查找影片。支持按片名、演员、导演等关键词进行检索。</p>
<h3>画质选择</h3>
<p>久久视频默认提供最高可用画质，你可以在播放页面根据网络状况自由切换蓝光、超清、高清等不同画质选项。</p>
<h3>收藏与历史</h3>
<p>注册账号后，你可以收藏喜欢的影片，系统也会自动记录你的观看历史，方便下次继续观看。</p>`,
    image: "https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20interface%20on%20laptop%20screen%20showing%20movie%20thumbnails%2C%20clean%20minimalist%20UI%20design%2C%20cozy%20home%20environment%2C%20warm%20evening%20lighting&width=1200&height=600&seq=article-05&orientation=landscape",
    tags: ["使用指南", "教程", "久久视频"],
  },
  {
    id: 6,
    title: "纪录片推荐：五部改变你世界观的自然纪录片",
    category: "documentary",
    date: "2026-07-05",
    author: "纪录片编辑阿久",
    summary: "好的纪录片能够开拓视野、启迪思考。我们精选了五部高品质的自然纪录片，带你领略地球的壮美与生命的神奇。",
    content: `<p>纪录片是最能直观展现世界之美的影视形式之一。以下五部自然纪录片，每一部都值得你花时间细细品味。</p>
<h3>《地球脉动》系列</h3>
<p>BBC出品的《地球脉动》系列被誉为自然纪录片的巅峰之作。从极地冰原到热带雨林，从深海世界到高山之巅，每一帧画面都是视觉盛宴。</p>
<h3>《蓝色星球》系列</h3>
<p>海洋覆盖了地球表面的71%，但对于大多数人来说，深海世界仍然充满神秘。《蓝色星球》系列用前所未有的视角展现了海洋的壮丽与脆弱。</p>
<h3>《我们的星球》</h3>
<p>Netflix出品的《我们的星球》采用了最新的4K摄影技术，画面精美绝伦。影片在展现自然之美的同时，也深刻探讨了气候变化对地球生态的影响。</p>`,
    image: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wild%20animals%20in%20their%20natural%20habitat%2C%20golden%20sunset%20over%20savanna%2C%20cinematic%20wildlife%20photography%2C%20warm%20natural%20lighting&width=1200&height=600&seq=article-06&orientation=landscape",
    tags: ["纪录片", "自然", "推荐"],
  },
];